import Modal from "components/Modal";
import { Uppdrag } from "types/uppdrag.type";
import { ModalContentWrapper } from "components/ModalContentWrapper";
import { FormProvider } from "react-hook-form";
import { TextInputFormProvider } from "components/TextInputFormProvider";
import Divider from "components/Divider";
import {
  ModalPrimaryButton,
  ModalSecondaryAction,
} from "../customer/AddFacility/AddFacilityModal";
import { useTimeReportLogic } from "./useTimeReportLogic";

type Props = {
  uppdrag: Uppdrag;
};
export const TimeReportModal = ({ uppdrag }: Props) => {
  const { isModalOpen, form, closeModal, afterClose, onSubmit, isPending } =
    useTimeReportLogic(uppdrag);
  return (
    <Modal
      isOpen={isModalOpen}
      title="Tidsrapportering"
      onClose={closeModal}
      afterClose={afterClose}
      hideButtons
    >
      <ModalContentWrapper>
        <FormProvider {...form}>
          <form onSubmit={onSubmit}>
            <TextInputFormProvider
              name="reportedWorkingHours"
              label="Arbetad tid"
              appendix="Timmar"
            />
            <TextInputFormProvider
              name="reportedDrivingHours"
              label="Körtid"
              appendix="Timmar"
              className="mt-4"
            />
            <Divider className="mb-4 mt-6" />
            <div className="flex justify-end">
              <div className="flex space-x-2 sm:w-72">
                <ModalSecondaryAction onClick={closeModal} />
                <ModalPrimaryButton
                  isLoading={isPending}
                  buttonText="Spara"
                  loadingText="Sparar"
                  isDisabled={isPending}
                />
              </div>
            </div>
          </form>
        </FormProvider>
      </ModalContentWrapper>
    </Modal>
    //  <Modal
    //         isOpen={isTimeReportModalOpen}
    //         title="Tidsrapportering"
    //         onClose={closeTimeReportModal}
    //         actionHandler={updateTimeReport}
    //         actionText="Spara"
    //         isLoading={isUpdatingTimeReport}
    //       >
    //         <TimeReportForm
    //           assignments={assignmentsWaitingForTimeReport}
    //           timeReportItems={timeReportItems}
    //           updateTimeReportItemHour={updateTimeReportItemHour}
    //           assignmentsWithFormErrors={assignmentsWithFormErrors}
    //         />
    //       </Modal>
  );
};
